import { CONTAINER_MAIN } from 'Constant';
import { createSelector } from 'reselect';
import { selectSubscription } from '../Tariff/selectors';
import { initialState } from './reducer';

const selectState = (state) => state[CONTAINER_MAIN] || initialState;

const selectLoading = () =>
    createSelector(
        selectState,
        state => state.loading,
    );

const selectDevice = () =>
    createSelector(
        selectState,
        state => state.payload,
    );

const selectHardwareOnly = () =>
    createSelector(
        selectState,
        state => state.isHardwareOnly,
    );

const selectName = () =>
    createSelector(
        selectState,
        (state) => state.payload.name,
    );

const selectVendor = () =>
    createSelector(
        selectState,
        (state) => state.payload.vendor,
    );

const selectInsurance = () =>
    createSelector(
        selectState,
        (state) => state.payload.insurance,
    );

const selectInsuranceSelected = () =>
    createSelector(
        selectState,
        state => state.insuranceSelected,
    );

const selectForceRerender = () =>
    createSelector(
        selectState,
        state => state.forceRerender,
    );

const selectTradeIn = () =>
    createSelector(
        selectState,
        state => state.isTradeIn,
    );

const selectOffer = () =>
    createSelector(
        selectState, selectSubscription(), selectInsurance(),
        (state, subscription, insurance) => state.payload && ({ ...subscription, insurance }),
    );

export {
    selectLoading,
    selectDevice,
    selectHardwareOnly,
    selectName,
    selectVendor,
    selectInsurance,
    selectInsuranceSelected,
    selectForceRerender,
    selectTradeIn,
    selectOffer,
};
